export default {
  shape: 'Forme | Formes',
  icons: 'Icônes',
  properties: 'Propriétés',
  color: 'Couleur',
  fill: 'Remplir',
  stroke: 'Stroke',
  strokeWidth: 'Stroke width',
  strokeType: 'Stroke type',
  fontColor: 'Couleur de la police',
  fontSize: 'Taille de police',
  fontBackgroundColor: 'Couleur de fond de la police',
  lineType: 'Type de ligne',
  backgroundColor: 'Couleur de l\'arrière plan',
  shapes: {
    rectangle: 'Rectangle',
    roundedRectangle: 'Rectangle arrondi',
    square: 'Square',
    rhombus: 'Rhombus',
    circle: 'Circle',
    ellipse: 'Ellipse',
    parallelogram: 'Parallélogramme',
    process: 'Process',
    document: 'Document',
    storage: 'Storage',
    curve: 'Curve',
    curveArrow: 'Curve arrow',
    bidirectionalCurve: 'Bidirectional curve',
    line: 'Line',
    arrowLine: 'Arrow line',
    bidirectionalArrowLine: 'Bidirectional arrow line',
    text: 'Text',
    textbox: 'Textbox',
    image: 'Image',
  },
  panzoom: {
    helpText: 'Raccourcis utiles :\n'
      + 'Ctrl + molette de la souris - zoom avant/arrière\n'
      + 'Ctrl + Clic gauche de la souris + glisser - déplacer la zone\n'
      + 'Clic du milieu de la souris + glisser - déplacer la zone\n'
      + 'Maj + molette de la souris - défilement horizontal\n'
      + 'Alt + molette de la souris - défilement vertical\n',
  },
  errors: {
    pointsRequired: 'Un point doit être ajouté',
  },
};
